import { render, staticRenderFns } from "./ChatroomLiveBot.vue?vue&type=template&id=f94d24d8&scoped=true&"
import script from "./ChatroomLiveBot.vue?vue&type=script&lang=js&"
export * from "./ChatroomLiveBot.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomLiveBot.vue?vue&type=style&index=0&id=f94d24d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94d24d8",
  null
  
)

export default component.exports